// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1d2Gs","title":"AfterBackImages_title__25sN1","images":"AfterBackImages_images__TWaZa"};